var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0007 1.06689L13.7173 5.00023H8.33398V8.33356L4.95065 10.4836C3.98398 11.0669 3.33398 12.1169 3.33398 13.3336V30.0002C3.33398 30.8843 3.68517 31.7321 4.31029 32.3573C4.93542 32.9824 5.78326 33.3336 6.66732 33.3336H33.334C35.184 33.3336 36.6673 31.8502 36.6673 30.0002V13.3336C36.6673 12.1169 36.0173 11.0669 35.0507 10.4836L31.6673 8.33356V5.00023H26.284M11.6673 8.33356H28.334V16.4669L20.0007 21.6669L11.6673 16.4669M13.334 10.0002V12.5002H26.6673V10.0002M8.33398 12.3002V14.3836L6.66732 13.3336M31.6673 12.3002L33.334 13.3336L31.6673 14.3836M13.334 14.1669V16.6669H26.6673V14.1669H13.334Z",
    fill: "#E74444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.cab20bc2de4102f11004e7ba690b6f8f.svg";
export { ForwardRef as ReactComponent };